__turbopack_context__.v({
  "card": "kV_aGG_card",
  "card--placeholder": "kV_aGG_card--placeholder",
  "image": "kV_aGG_image",
  "name": "kV_aGG_name",
  "shimmer": "kV_aGG_shimmer",
  "text-bar-sweep": "kV_aGG_text-bar-sweep",
});
